import { DescendantResource, Id, TranslationEntry } from "@dgs/core";

export enum OrganizerType {
	COMPANY = "company",
	PUBlIC_ORGANIZATION = "publicOrganization",
	NON_PROFIT_ORGANIZATION = "nonProfitOrganization",
	PUBLIC_AUTHORITY = "publicAuthority",
	MEDIA = "media",
	POLITICAL_ORGANIZATION = "politicalOrganization",
	EDUCATIONAL_INSTITUTION = "educationalInstitution",
}

export interface OrganizerTranslationEntry {
	description: DescendantResource[];
}

export interface OrganizerOptionResource {
	id: Id;
	name: string;
	description: DescendantResource[] | null;
}

export interface OrganizerFormValues {
	name: string;
	type: OrganizerType;
	translations: TranslationEntry<OrganizerTranslationEntry>[];
}

export interface OrganizerSaveRequest {
	name: string;
	type: OrganizerType;
	translations: TranslationEntry<OrganizerTranslationEntry>[];
}

export interface OrganizerIndexResource {
	id: number;
	name: string;
	type: OrganizerType;
}
